import { InstantMessagesApi as api } from '../api/InstantMessagesApi'

export default function getStore(Vue) {
  return {
    state: {
      messages: []
    },
    mutations: {
      SET_MESSAGES(state, { messages, emitEvent }) {
        state.messages = messages
        if (emitEvent) {
          Vue.$notificationsEventEmiter.callNotificationReceive(messages)
        }
      },
      async MARK_MESSAGE_AS_READ(state, id) {
        await api.markMessageAsRead(id)

        state.messages.forEach(x => {
          if (x.id === id) {
            // устанавливаем признак того, что уведомление прочитано и помечаем сообщение признаком flagged для того, 
            // чтобы оно не пропала из списка непрочитанных сообщений сразу после прочтения
            x.isRead = x.flagged = true
          }
        })
      },
      async MARK_ALL_MESSAGE_AS_READ(state) {
        await api.markAllMessagesAsRead()
        state.messages.forEach((element) => {
          element.isRead = true
        })
      }
    },
    actions: {
      async fetchAllMessages({ commit }, { emitEvent, types }) {
        const data = await api.getAllMessages(types)
        const result = data.data.instantMessagesQuery.getAllMessages
        if (!result.length) {
          return
        }
        commit('SET_MESSAGES', { messages: result.reverse(), emitEvent })
      },

      async fetchUnreadMessages({ commit }, { emitEvent, types }) {
        const data = await api.getUnreadMessages(types)
        const result = data.data.instantMessagesQuery.getUnreadMessages
        if (!result.length) {
          return
        }
        commit('SET_MESSAGES', { messages: result, emitEvent })
      }
    },
    getters: {
      getMessages(state) {
        return state.messages
      }
    }
  }
}